module.exports = __webpack_public_path__ + "static/media/nc.b6c1c6b3.svg";